function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Form from "../../components/Form/Form";
import { DictText } from "../../components/Form/Text";
import { UploadSingleWithFileNameInLine } from "../../components/Form/Upload";
import HtmlText from "../../components/HtmlText";
import { get, post } from "../../utils";
import { Button, Input, Modal, Popover, Select, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { nanoid } from 'nanoid';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styles from "./index.module.css";
import Progress from "./Progress";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Reg = /^\d+(\.\d{1,4})?$/;
var Map = {
  1: {
    text: '是',
    value: 1
  },
  2: {
    text: '否',
    value: 2
  }
};
export var useDetail = function useDetail() {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var orderCode = useRef();
  orderCode.current = searchParams.get('orderCode');
  if (orderCode.current === 'null' || orderCode.current === 'undefined') {
    orderCode.current = undefined;
  }
  var ref = useRef(null);
  var ref2 = useRef(null);
  var modalRef = useRef();
  var _useState = useState(function () {
      return orderCode.current ? {} : {
        canEdit: true,
        type: 'request'
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    details = _useState4[0],
    setDetails = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    renderDetails = _useState6[0],
    setRenderDetails = _useState6[1];
  var _useState7 = useState(nanoid()),
    _useState8 = _slicedToArray(_useState7, 2),
    renderKey = _useState8[0],
    setRenderKey = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    category = _useState10[0],
    setCategory = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    activeCategory = _useState12[0],
    setActiveCategory = _useState12[1];
  var _useState13 = useState(true),
    _useState14 = _slicedToArray(_useState13, 2),
    expanded = _useState14[0],
    setExpanded = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    numberMap = _useState16[0],
    setNumberMap = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    filters = _useState18[0],
    setFilters = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    filters2 = _useState20[0],
    setFilters2 = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    loading = _useState22[0],
    setLoading = _useState22[1];
  useEffect(function () {
    orderCode.current && getDetail();
    getCategory();
  }, []);
  useEffect(function () {
    var map = {
      ALL: {
        numerator: 0,
        denominator: 0
      }
    };
    var ds = [];
    var ds2 = [];
    details.forEach(function (d) {
      map['ALL'].denominator += 1;
      if (d.customized != null && !ds.includes(d.customized)) {
        ds.push(d.customized);
      }
      if (d.supplierName != null && !ds2.includes(d.supplierName) && d.supplierName) {
        ds2.push(d.supplierName);
      }
      if (!map[d.parentCategoryCode]) {
        map[d.parentCategoryCode] = {
          numerator: 0,
          denominator: 0
        };
      }
      if (!map[d.categoryCode]) {
        map[d.categoryCode] = {
          numerator: 0,
          denominator: 0
        };
      }
      map[d.categoryCode].denominator += 1;
      map[d.parentCategoryCode].denominator += 1;
      if (Number(d.requestQty) > 0) {
        map['ALL'].numerator += 1;
        map[d.categoryCode].numerator += 1;
        map[d.parentCategoryCode].numerator += 1;
      }
    });
    setNumberMap(map);
    setFilters(ds.sort().map(function (e) {
      return Map[e];
    }));
    ds2.length > 0 && setFilters2(ds2.map(function (e) {
      return {
        value: e,
        text: e
      };
    }));
  }, [details]);
  var onSkuListQuery = function onSkuListQuery(values) {
    var _ref$current;
    var form = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.form;
    var _ref = values || {},
      _ref$orgCode = _ref.orgCode,
      orgCode = _ref$orgCode === void 0 ? form === null || form === void 0 ? void 0 : form.getFieldValue('orgCode') : _ref$orgCode,
      _ref$requestType = _ref.requestType,
      requestType = _ref$requestType === void 0 ? form === null || form === void 0 ? void 0 : form.getFieldValue('requestType') : _ref$requestType;
    post({
      url: "/erp/scm/request/skuVoList",
      data: {
        orgCode: orgCode,
        requestType: requestType
      }
    }).then(function (result) {
      var _ref2 = result || {},
        code = _ref2.code,
        d = _ref2.data;
      if (code === 0) {
        var ds = d.map(function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            nanoid: nanoid()
          });
        });
        setDetails(ds);
        setRenderDetails(ds);
      }
    });
  };
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    curSearchText = _useState24[0],
    setCurSearchText = _useState24[1];
  var onSearchDetail = function onSearchDetail(searchText) {
    setCurSearchText(searchText);
    setRenderDetails(details.filter(function (v) {
      var _v$skuCode, _v$skuName;
      return (((_v$skuCode = v.skuCode) === null || _v$skuCode === void 0 ? void 0 : _v$skuCode.includes(searchText)) || ((_v$skuName = v.skuName) === null || _v$skuName === void 0 ? void 0 : _v$skuName.includes(searchText))) && !(activeCategory && activeCategory !== v.categoryCode && activeCategory !== 'ALL' && activeCategory !== v.parentCategoryCode);
    }));
  };
  var onResetSearch = function onResetSearch() {
    setRenderDetails(details.filter(function (v) {
      return !(activeCategory && activeCategory !== v.categoryCode && activeCategory !== 'ALL' && activeCategory !== v.parentCategoryCode);
    }));
  };
  var onSelectCategory = function onSelectCategory(key) {
    setActiveCategory(key);
    setRenderDetails(details.filter(function (v) {
      var _v$skuCode2, _v$skuName2;
      return (((_v$skuCode2 = v.skuCode) === null || _v$skuCode2 === void 0 ? void 0 : _v$skuCode2.includes(curSearchText)) || ((_v$skuName2 = v.skuName) === null || _v$skuName2 === void 0 ? void 0 : _v$skuName2.includes(curSearchText)) || !curSearchText) && !(key && key !== v.categoryCode && key !== 'ALL' && key !== v.parentCategoryCode);
    }));
  };
  var getDetail = function getDetail() {
    if (!orderCode.current) {
      message.warning('缺少订单号');
      return;
    }
    setLoading(true);
    get({
      url: "/erp/scm/request/detail?orderCode=".concat(orderCode.current)
    }).then(function (result) {
      var _ref3 = result || {},
        code = _ref3.code,
        d = _ref3.data;
      if (code === 0) {
        var _ref$current2;
        (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.form.setFieldsValue(d);
        var ds = d.canEdit ? d.details.map(function (e) {
          return _objectSpread(_objectSpread({}, e), {}, {
            nanoid: nanoid()
          });
        }) : d.details;
        setDetails(ds);
        setRenderDetails(ds);
        setData(d);
      }
    }).catch(function () {}).finally(function () {
      setLoading(false);
    });
  };
  var getCategory = function getCategory() {
    get({
      url: "/erp/scm/request/categoryVoList"
    }).then(function (result) {
      var _ref4 = result || {},
        code = _ref4.code,
        d = _ref4.data;
      if (code === 0) {
        var buildCategory = function buildCategory(ls) {
          return ls.map(function () {
            var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              code = _ref5.code,
              name = _ref5.name,
              children = _ref5.children;
            return {
              key: code,
              title: "".concat(code, " \uFF08").concat(name, ")"),
              isLeaf: !(children && children.length > 0),
              children: children ? buildCategory(children) : []
            };
          });
        };
        setCategory([{
          title: '全部分类',
          key: 'ALL',
          children: buildCategory(d)
        }]);
      }
    });
  };
  var onSave = function onSave() {
    var _ref$current3;
    var values = (_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.form.getFieldsValue();
    // 过滤掉details中数量为空或者等于0的项
    var tempDetails = details.filter(function (d) {
      return d.requestQty && d.requestQty > 0;
    });
    post({
      url: '/erp/scm/request/save',
      data: _objectSpread(_objectSpread(_objectSpread({}, data), values), {}, {
        details: tempDetails
      })
    }).then(function (result) {
      var code = result.code,
        d = result.data;
      if (code === 0) {
        message.success('保存成功！');
        if (d) {
          orderCode.current = d;
          window.location.search = "?orderCode=".concat(d);
        }
      }
    }).catch(function () {});
  };
  var onRefresh = function onRefresh() {
    var _ref$current4;
    modalRef.current = Modal.confirm({
      title: '数据更新中...',
      className: styles.modal,
      icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
        style: {
          color: 'rgba(247, 114, 52, 1)'
        }
      }),
      content: /*#__PURE__*/_jsx(Progress, {
        maxTime: 6
      }),
      footer: /*#__PURE__*/_jsx(_Fragment, {})
    });
    get({
      url: '/adaptor/kingdee-adaptor/refreshSku/refresh',
      query: {
        orgCode: (_ref$current4 = ref.current) === null || _ref$current4 === void 0 ? void 0 : _ref$current4.form.getFieldValue('orgCode')
      }
    }).then(function (result) {
      var _modalRef$current;
      (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 || _modalRef$current.destroy();
      var code = result.code,
        d = result.data;
      if (code === 0 && d) {
        message.success('刷新成功！');
        getDetail();
      }
    }).catch(function () {
      var _modalRef$current2;
      (_modalRef$current2 = modalRef.current) === null || _modalRef$current2 === void 0 || _modalRef$current2.destroy();
    });
  };
  var onSubmit = function onSubmit(text, path) {
    var _ref$current5;
    (_ref$current5 = ref.current) === null || _ref$current5 === void 0 || _ref$current5.form.validateFields().then(function (values) {
      var footer = /*#__PURE__*/_jsxs("div", {
        className: styles.filterFooter,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return modal.destroy();
          },
          children: "\u53D6\u6D88"
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            modal.update({
              footer: /*#__PURE__*/_jsxs("div", {
                className: styles.filterFooter,
                children: [/*#__PURE__*/_jsx(Button, {
                  onClick: function onClick() {
                    return modal.destroy();
                  },
                  children: "\u53D6\u6D88"
                }), /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  loading: true,
                  children: "\u786E\u5B9A"
                })]
              })
            });
            // 过滤掉details中数量为空或者等于0的项
            var tempDetails = details.filter(function (d) {
              return d.requestQty && d.requestQty > 0;
            });
            post({
              url: "/erp/scm/request/".concat(path),
              data: _objectSpread(_objectSpread(_objectSpread({}, data), values), {}, {
                details: tempDetails
              })
            }).then(function (result) {
              var code = result.code,
                d = result.data;
              if (code === 0) {
                message.success("".concat(text, "\u6210\u529F\uFF01"));
                if (d) {
                  orderCode.current = d;
                  window.location.search = "?orderCode=".concat(d);
                }
                modal.destroy();
              } else {
                modal.update({
                  footer: footer
                });
              }
            }).catch(function () {
              modal.update({
                footer: footer
              });
            });
          },
          children: "\u786E\u5B9A"
        })]
      });
      var modal = Modal.confirm({
        className: styles.modal,
        title: "\u786E\u8BA4".concat(text, "\u5417?"),
        content: /*#__PURE__*/_jsx("span", {
          style: {
            color: '#6E707A'
          },
          children: "\u8BF7\u4ED4\u7EC6\u6838\u5BF9\u4FE1\u606F\u786E\u8BA4\u65E0\u8BEF"
        }),
        icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
          style: {
            color: 'rgba(247, 114, 52, 1)'
          }
        }),
        okButtonProps: {
          className: styles.ok
        },
        cancelButtonProps: {
          className: styles.cancel
        },
        footer: footer
      });
    }).catch(function () {});
  };
  var onReject = function onReject(text, path) {
    var modal = Modal.confirm({
      className: styles.modal,
      title: "\u786E\u8BA4".concat(text, "\u5417?"),
      content: /*#__PURE__*/_jsx(Form, {
        layout: "vertical",
        ref: ref2,
        mode: "edit",
        labelCol: {
          className: styles.label
        },
        children: /*#__PURE__*/_jsxs(Form.Field, {
          name: "remark",
          label: "".concat(text, "\u539F\u56E0"),
          required: true,
          rules: [{
            required: true,
            message: "".concat(text, "\u539F\u56E0")
          }],
          children: [/*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165".concat(text, "\u539F\u56E0")
          }), /*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: "\u8BF7\u8F93\u5165".concat(text, "\u539F\u56E0")
          })]
        })
      }),
      icon: /*#__PURE__*/_jsx(ExclamationCircleOutlined, {
        style: {
          color: 'rgba(247, 114, 52, 1)'
        }
      }),
      okButtonProps: {
        className: styles.ok
      },
      cancelButtonProps: {
        className: styles.cancel
      },
      footer: /*#__PURE__*/_jsxs("div", {
        className: styles.filterFooter,
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return modal.destroy();
          },
          children: "\u53D6\u6D88"
        }), /*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            var _ref2$current;
            (_ref2$current = ref2.current) === null || _ref2$current === void 0 || _ref2$current.form.validateFields().then(function (values) {
              post({
                url: "/erp/scm/request/".concat(path),
                data: _objectSpread(_objectSpread({}, values), {}, {
                  orderCode: orderCode.current
                })
              }).then(function (result) {
                var code = result.code,
                  d = result.data;
                if (code === 0) {
                  message.success("".concat(text, "\u6210\u529F\uFF01"));
                  getDetail();
                  modal.destroy();
                }
              }).catch(function () {});
            }).catch(function () {});
          },
          children: "\u786E\u5B9A"
        })]
      })
    });
  };
  var onExport = function onExport() {
    get({
      url: '/erp/scm/request/exportRequestOrderDetail',
      query: {
        orderCode: orderCode.current
      }
    }).then(function (result) {
      var code = result.code,
        d = result.data;
      if (code === 0) {
        window.open(d);
      }
    }).catch(function () {});
  };
  var onDetailChange = function onDetailChange(data) {
    setDetails(details.map(function (e) {
      return e.nanoid === data.nanoid ? _objectSpread(_objectSpread({}, e), data) : e;
    }));
    setRenderDetails(renderDetails.map(function (e) {
      return e.nanoid === data.nanoid ? _objectSpread(_objectSpread({}, e), data) : e;
    }));
    setRenderKey(nanoid());
  };
  var _onKeyDown = function onKeyDown(type, index) {
    var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      keyCode: -1
    };
    // 下
    if (e.keyCode === 40) {
      var _document$getElementB3;
      if (index === renderDetails.length - 1 && type === 'qty') {
        var _document$getElementB;
        (_document$getElementB = document.getElementById("qty-".concat(index))) === null || _document$getElementB === void 0 || _document$getElementB.blur();
        setTimeout(function () {
          var _document$getElementB2;
          (_document$getElementB2 = document.getElementById("remark-".concat(index))) === null || _document$getElementB2 === void 0 || _document$getElementB2.focus();
        }, 100);
        return;
      } else if (index === renderDetails.length - 1) {
        return;
      }
      (_document$getElementB3 = document.getElementById("".concat(type, "-").concat(index))) === null || _document$getElementB3 === void 0 || _document$getElementB3.blur();
      setTimeout(function () {
        var _document$getElementB4;
        (_document$getElementB4 = document.getElementById("".concat(type, "-").concat(index + 1))) === null || _document$getElementB4 === void 0 || _document$getElementB4.focus();
      }, 100);
      return;
      // 上
    } else if (e.keyCode === 38) {
      var _document$getElementB7;
      if (index === 0 && type === 'remark') {
        var _document$getElementB5;
        (_document$getElementB5 = document.getElementById("remark-".concat(index))) === null || _document$getElementB5 === void 0 || _document$getElementB5.blur();
        setTimeout(function () {
          var _document$getElementB6;
          (_document$getElementB6 = document.getElementById("qty-".concat(index))) === null || _document$getElementB6 === void 0 || _document$getElementB6.focus();
        }, 100);
        return;
      } else if (index === 0) {
        return;
      }
      (_document$getElementB7 = document.getElementById("".concat(type, "-").concat(index))) === null || _document$getElementB7 === void 0 || _document$getElementB7.blur();
      setTimeout(function () {
        var _document$getElementB8;
        (_document$getElementB8 = document.getElementById("".concat(type, "-").concat(index - 1))) === null || _document$getElementB8 === void 0 || _document$getElementB8.focus();
      }, 100);
      return;
      // 左
      // } else if (e.keyCode === 37) {
      //   if (type === 'remark') {
      //     document.getElementById(`remark-${index}`)?.blur()
      //     setTimeout(() => {
      //       document.getElementById(`qty-${index}`)?.focus()
      //     }, 100)
      //   } else if (index === 0) {
      //     return
      //   } else {
      //     document.getElementById(`qty-${index}`)?.blur()
      //     setTimeout(() => {
      //       document.getElementById(`remark-${index - 1}`)?.focus()
      //     }, 100)
      //   }
      //   // 右
      // } else if (e.keyCode === 39) {
      //   if (type === 'qty') {
      //     document.getElementById(`qty-${index}`)?.blur()
      //     setTimeout(() => {
      //       document.getElementById(`remark-${index}`)?.focus()
      //     }, 100)
      //   } else if (index === renderDetails.length - 1) {
      //     return
      //   } else {
      //     document.getElementById(`remark-${index}`)?.blur()
      //     setTimeout(() => {
      //       document.getElementById(`qty-${index + 1}`)?.focus()
      //     }, 100)
      //   }
    }
  };
  var onCopy = function onCopy(record) {
    var index = details.findIndex(function (d) {
      return d.nanoid === record.nanoid;
    });
    var index2 = renderDetails.findIndex(function (d) {
      return d.nanoid === record.nanoid;
    });
    var d1 = _toConsumableArray(details);
    var d2 = _toConsumableArray(renderDetails);
    var id = nanoid();
    d1.splice(index + 1, 0, _objectSpread(_objectSpread({}, record), {}, {
      uniqKey: undefined,
      nanoid: id,
      requestQty: 0,
      remark: undefined,
      attachment: undefined
    }));
    d2.splice(index2 + 1, 0, _objectSpread(_objectSpread({}, record), {}, {
      uniqKey: undefined,
      nanoid: id,
      requestQty: 0,
      remark: undefined,
      attachment: undefined
    }));
    setDetails(d1);
    setRenderDetails(d2);
  };
  var detailCol2 = [{
    title: '单价',
    align: 'right',
    className: styles.min90,
    dataIndex: 'price'
  }, {
    title: '含税单价',
    dataIndex: 'taxPrice',
    align: 'right',
    className: styles.min90
  }, {
    title: '采购金额',
    dataIndex: 'amount',
    align: 'right',
    className: styles.min90
  }, {
    title: '税率',
    dataIndex: 'taxRate',
    align: 'right',
    className: styles.min90,
    render: function render(v) {
      return v ? "".concat(v, "%") : '-';
    }
  }, {
    title: '内部销售结算价',
    dataIndex: 'internalPrice',
    align: 'right',
    className: styles.min120
  }, {
    title: '内部销售加成百分比',
    dataIndex: 'internalRate',
    align: 'right',
    className: styles.min150,
    render: function render(v) {
      return v ? "".concat(v, "%") : '-';
    }
  }, {
    title: '销售金额',
    dataIndex: 'salesAmount',
    align: 'right',
    className: styles.min90
  }, {
    title: '错误原因',
    dataIndex: 'errorMessage',
    className: styles.maxWidth240,
    render: function render(v) {
      return /*#__PURE__*/_jsx(Popover, {
        style: {
          maxWidth: 400
        },
        content: /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 400
          },
          children: /*#__PURE__*/_jsx(HtmlText, {
            style: {
              color: '#D54941'
            },
            children: v
          })
        }),
        trigger: "hover",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.reasonText,
          children: v
        })
      });
    }
  }];
  var dc = data.canEdit ? [{
    title: '操作',
    fixed: 'right',
    render: function render(value, record) {
      return /*#__PURE__*/_jsx("span", {
        className: styles.edit,
        onClick: function onClick() {
          return onCopy(record);
        },
        children: "\u590D\u5236"
      });
    }
  }] : detailCol2;
  var detailCol = [{
    title: '序号',
    dataIndex: 'flowOrderCode',
    width: 55,
    fixed: 'left',
    render: function render(a, b, index) {
      return index + 1;
    }
  }, {
    title: '商品名称',
    dataIndex: 'skuName',
    className: styles.min90,
    sorter: function sorter(a, b) {
      return a.skuName && b.skuName ? a.skuName.localeCompare(b.skuName) : 0;
    },
    fixed: 'left'
  }, {
    title: '商品编码',
    dataIndex: 'skuCode',
    className: styles.min90,
    sorter: function sorter(a, b) {
      return a.skuCode && b.skuCode ? a.skuCode.localeCompare(b.skuCode) : 0;
    }
  }, {
    title: '品项名称',
    dataIndex: 'categoryName',
    className: styles.min90,
    sorter: function sorter(a, b) {
      return a.categoryName.localeCompare(b.categoryName);
    },
    render: function render(v, r) {
      return "".concat(r.categoryCode, "\uFF08").concat(v || '', "\uFF09");
    }
  }, {
    title: '供应商',
    className: styles.min120,
    dataIndex: 'supplierName',
    filters: filters2,
    onFilter: function onFilter(value, record) {
      return record.supplierName === value;
    }
  }, {
    title: '描述',
    dataIndex: 'skuDescription',
    className: styles.maxWidth240,
    render: function render(v) {
      return v ? /*#__PURE__*/_jsx(Popover, {
        style: {
          maxWidth: 400
        },
        content: /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 400
          },
          children: /*#__PURE__*/_jsx(HtmlText, {
            children: v
          })
        }),
        trigger: "hover",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.popText,
          children: v
        })
      }) : '-';
    }
  }, {
    title: '是否定制品',
    dataIndex: 'customized',
    className: styles.min120,
    filters: filters,
    onFilter: function onFilter(value, record) {
      return record.customized === value;
    },
    render: function render(v) {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.customized,
        children: [/*#__PURE__*/_jsx("div", {
          className: v === 2 ? styles.grayIcon : styles.redIcon
        }), /*#__PURE__*/_jsx(DictText, {
          dictType: "scm_is_customized",
          value: v
        })]
      });
    }
  }, {
    title: '单位',
    dataIndex: 'unit',
    className: styles.min60
  }, {
    title: '规格',
    dataIndex: 'spec',
    className: styles.min60
  }, {
    title: '数量',
    dataIndex: 'requestQty',
    align: 'right',
    className: styles.min60,
    sorter: function sorter(a, b) {
      return (a.requestQty ? String(a.requestQty) : '0').localeCompare(b.requestQty ? String(b.requestQty) : '0');
    },
    render: function render(v, record, index) {
      return data.canEdit ? /*#__PURE__*/_jsx(Input, {
        id: "qty-".concat(index),
        placeholder: "\u8BF7\u8F93\u6570\u91CF",
        style: {
          width: 75,
          textAlign: 'right'
        },
        defaultValue: v,
        size: "small",
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown('qty', index, e);
        },
        onBlur: function onBlur(e) {
          onDetailChange({
            nanoid: record.nanoid,
            requestQty: Reg.test(e.target.value) ? Number(e.target.value) : undefined
          });
        }
      }, "".concat(record.nanoid, "-").concat(renderKey, "-").concat(index)) : v || '-';
    }
  }, {
    title: '配送类型',
    className: styles.min90,
    dataIndex: 'deliveryType',
    render: function render(v) {
      return /*#__PURE__*/_jsx(DictText, {
        dictType: "scm_delivery_type",
        value: v
      });
    }
  }, {
    title: '仓库',
    className: styles.min120,
    dataIndex: ['virtualWhName'],
    render: function render(v, record, index) {
      if (!data.canEdit) {
        return v || '-';
      }
      var _record$extendMap = record.extendMap,
        extendMap = _record$extendMap === void 0 ? {} : _record$extendMap,
        virtualWhCode = record.virtualWhCode,
        deliveryType = record.deliveryType;
      var hidden = deliveryType !== 'PSLXTP'; // 配送非"统配", 不展示仓库和物流服务商
      if (hidden) {
        return '-';
      }
      var options = Object.keys(extendMap).map(function (key) {
        var item = extendMap[key];
        var value = item.virtualWhCode;
        var label = item.virtualWhName;
        return {
          label: label,
          value: value,
          item: item
        };
      });
      return /*#__PURE__*/_jsx(Select, {
        id: "vwn-".concat(index),
        style: {
          minWidth: 120
        },
        placeholder: "\u8BF7\u9009\u62E9",
        size: "small",
        allowClear: true,
        options: options,
        defaultValue: virtualWhCode,
        onChange: function onChange(val) {
          var matchItem = options.find(function (i) {
            return i.value === val;
          });
          var _ref6 = (matchItem === null || matchItem === void 0 ? void 0 : matchItem.item) || {},
            logisticsServiceName = _ref6.logisticsServiceName,
            internalPrice = _ref6.internalPrice,
            internalRate = _ref6.internalRate,
            price = _ref6.price,
            taxPrice = _ref6.taxPrice,
            taxRate = _ref6.taxRate;
          onDetailChange({
            nanoid: record.nanoid,
            virtualWhCode: matchItem === null || matchItem === void 0 ? void 0 : matchItem.value,
            virtualWhName: matchItem === null || matchItem === void 0 ? void 0 : matchItem.label,
            logisticsServiceName: logisticsServiceName,
            internalPrice: internalPrice,
            internalRate: internalRate,
            price: price,
            taxRate: taxRate,
            taxPrice: taxPrice
          });
        }
      }, "".concat(record.nanoid, "-").concat(renderKey, "-").concat(index));
    }
  }, {
    title: '三方物流服务商',
    className: styles.min120,
    dataIndex: ['logisticsServiceName'],
    render: function render(v, record) {
      var deliveryType = record.deliveryType;
      var hidden = deliveryType !== 'PSLXTP'; // 配送非"统配", 不展示仓库和物流服务商
      if (hidden) {
        return '-';
      }
      return v;
    }
  }, {
    title: '备注',
    dataIndex: 'remark',
    className: styles.maxWidth160,
    render: function render(v, record, index) {
      return data.canEdit ? /*#__PURE__*/_jsx(Input, {
        id: "remark-".concat(index),
        placeholder: "\u8BF7\u8F93\u5165\u5907\u6CE8",
        defaultValue: v,
        size: "small",
        onKeyDown: function onKeyDown(e) {
          return _onKeyDown('remark', index, e);
        },
        onBlur: function onBlur(e) {
          onDetailChange({
            nanoid: record.nanoid,
            remark: e.target.value
          });
        }
      }, "".concat(record.nanoid, "-").concat(renderKey, "-").concat(index)) : v ? /*#__PURE__*/_jsx(Popover, {
        style: {
          maxWidth: 400
        },
        content: /*#__PURE__*/_jsx("div", {
          style: {
            maxWidth: 400
          },
          children: /*#__PURE__*/_jsx(HtmlText, {
            children: v
          })
        }),
        trigger: "hover",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.popText,
          children: v
        })
      }) : '-';
    }
  }, {
    title: '附件',
    dataIndex: 'attachment',
    align: 'center',
    className: styles.maxWidth160,
    render: function render(v, record, index) {
      return data.canEdit ? /*#__PURE__*/_jsx(UploadSingleWithFileNameInLine, {
        value: v,
        onChange: function onChange(v) {
          onDetailChange({
            nanoid: record.nanoid,
            attachment: v
          });
        }
      }, "".concat(record.nanoid, "-").concat(index)) : /*#__PURE__*/_jsx(UploadSingleWithFileNameInLine, {
        value: v,
        disabled: true
      });
    }
  }].concat(_toConsumableArray(dc));
  return {
    data: {
      ref: ref,
      orderCode: orderCode.current,
      data: data,
      loading: loading,
      renderDetails: renderDetails,
      detailCol: detailCol,
      category: category,
      expanded: expanded,
      numberMap: numberMap,
      renderKey: renderKey,
      activeCategory: activeCategory
    },
    action: {
      onSkuListQuery: onSkuListQuery,
      onSave: onSave,
      onSubmit: onSubmit,
      onExport: onExport,
      onReject: onReject,
      setDetails: setDetails,
      setRenderDetails: setRenderDetails,
      onRefresh: onRefresh,
      setRenderKey: setRenderKey,
      onResetSearch: onResetSearch,
      onSelectCategory: onSelectCategory,
      onSearchDetail: onSearchDetail,
      setExpanded: setExpanded
    }
  };
};